import axios from "axios";

export const TOKEN_KEY = "bhism_admin_token";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => `${Array.isArray(e?.loc) ? e.loc[e.loc.length - 1] + ": " : ""}${e?.msg ?? ""}`)
      .join(" · ");
  }
  return detail?.msg ?? String(detail);
}

export const EASE = [0.16, 1, 0.3, 1];
